import React from 'react'
import { Card, CardBody, Text, Box } from 'grommet'
import { useDispatch } from 'react-redux'
import { ActionCreators, AlarmUtils, DateTimeUtils, Utils } from 'galarm-shared'
import { GlobalConfig, I18n } from 'galarm-config'
import BigText from './BigText'
import { SecondaryText } from 'web-components'

const IncidentAlarmSummary = ({ item }) => {
  const dispatch = useDispatch()

  const { id, date, dateString, name, status, type, backupContacts } = item

  const alarmDate = date
  const alarmExpired = AlarmUtils.hasParticipantAlarmExpired(id)

  let textColor

  if (!status) {
    textColor = 'darkTint'
  } else if (alarmExpired) {
    textColor = 'warningTextColor'
  } else {
    textColor = 'textColor'
  }

  const displayTimeString = DateTimeUtils.getTimeAsString(alarmDate)
  const displayDateString =
    DateTimeUtils.getLocalizedDayDateWithYearForLaterDatesAsString(alarmDate)

  const participant = Utils.getObjectWithId(backupContacts, GlobalConfig.uid)
  const snoozeTime =
    participant.lastSnoozeOn + participant.lastSnoozeFor || Date.now()
  const alarmInSnooze = snoozeTime > Date.now()
  const snoozeTimeString = DateTimeUtils.isDateToday(snoozeTime)
    ? DateTimeUtils.getTimeAsString(snoozeTime)
    : DateTimeUtils.getLocalizedDateTimeWoYearAsString(snoozeTime)

  const alarmAcknowledgement =
    AlarmUtils.getIncidentAlarmAcknowledgementStatusForOccurrence(
      id,
      dateString
    )

  console.log('Rendering IncidentAlarmSummary')

  return (
    <Card
      onClick={() => {
        dispatch(ActionCreators.showIncidentAlarmDetailsScreen(item.id))
      }}
      background="textBackgroundColor">
      <CardBody direction="row" justify="between">
        <Box pad="small">
          <Text color={textColor} truncate>
            {name}
          </Text>
          <Box direction="row" gap="xsmall">
            <BigText color={textColor}>{displayTimeString}</BigText>
            <Text alignSelf="end" color={textColor}>
              {' ' + displayDateString}
            </Text>
          </Box>
        </Box>
        <Box pad="small" justify="between" align="end">
          {alarmInSnooze && alarmExpired && !alarmAcknowledgement && status && (
            <Box direction="row" justify="end">
              <SecondaryText>
                {I18n.t('snoozing', { timeString: snoozeTimeString })}
              </SecondaryText>
            </Box>
          )}
          {!!alarmAcknowledgement && (
            <SecondaryText>
              {AlarmUtils.getAlarmAcknowledString(type, alarmAcknowledgement)}
            </SecondaryText>
          )}
          {!alarmInSnooze && !alarmAcknowledgement && <Box />}
        </Box>
      </CardBody>
    </Card>
  )
}

export default IncidentAlarmSummary
